import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=a88fcfdc&scoped=true"
import script from "./distribute.vue?vue&type=script&lang=js"
export * from "./distribute.vue?vue&type=script&lang=js"
import style0 from "./distribute.vue?vue&type=style&index=0&id=a88fcfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88fcfdc",
  null
  
)

export default component.exports